/* @flow */
import React from 'react';
import styled from 'styled-components';
import {
  Table,
  // $FlowFixMe
} from '@bijie/react-bnb';
import Spinner from './Spinner';

const TableWrapper = styled.div`
  position: relative;
  .mask {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: white;
    opacity: ${({ loading }) => loading ? '.9' : '0'};
    pointer-events: none;
  }
  .bnc-table th, .bnc-table td {
    white-space: pre-wrap;
    word-break: break-all;
  }
  ${({ theme }) => theme.mode === 'DARK' ? `
    .bnc-table .bnc-table-placeholder {
      background-color: ${theme.referral.backgroundColor};
      border-bottom: none;
    }
    .bnc-table th,
    .bnc-table-head th {
      background-color: ${theme.referral.layoutBackgroundColor};
      color: ${theme.referral.labelColor};
    }
    .bnc-table-tbody td {
      background-color: ${theme.referral.backgroundColor};
      color: ${theme.referral.pColor};
    }
    .bnc-table td,
    .bnc-table-row {
      border-bottom: ${theme.referral.modalBorder};
    }
  ` : ''}
`;

const EmptyBox = styled.div`
  padding-top: 34px;
  text-align: center;
  color: ${({ theme }) => theme.mode === 'DARK' ? theme.referral.pColor : ' #212833'};
  .norecord {
    display: inline-block;
    width: 120px;
    height: 120px;
    margin-bottom: 20px;
  }
  .norecord-tip {
    color: ${({ theme }) => theme.mode === 'DARK' ? theme.referral.pColor : ' #212833'};
    line-height: 20px;
    font-size: 16px;
  }
`;

const EmptyTable = ({
  loading, emptyText, noDataTips, ...props
}: Object) => (
  <TableWrapper loading={loading}>
    <Table
      {...props}
      emptyText={
        <EmptyBox>
          <div className="norecord"><img src="/static/images/common/norecord.svg" alt="icon" /></div>
          <div className="norecord-tip">{noDataTips || "You don't have any notifications yet"}</div>
        </EmptyBox>
    }
    />
    <div className="mask"><Spinner /></div>
  </TableWrapper>
);

export const ImageBox = styled.span`
  display: inline-block;
  position: relative;
  width: ${({ size }) => `${size}px`};
  height: 0;
  float: left;
  margin-right: ${({ right = 6 }) => `${right}px`};
  padding-bottom: ${({ size }) => `${size}px`};
  &::before {
    content: ' ';
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: ${({ size }) => `${size}px`};
    height: ${({ size }) => `${size}px`};
    border: 1px solid #EAECEF;
    border-radius: 100%;
    opacity: ${({ needCircle = true }) => needCircle ? 1 : 0}
  }
  > img {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: ${({ size }) => `${size - 8}px`};
    height: ${({ size }) => `${size - 8}px`};
    margin: auto;
  }
`;

export default EmptyTable;
